<script setup lang="ts">
import { computed } from 'vue';

import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppButton, AppLinkButton } from '@libs/ui';
import type { AppButtonState } from '@libs/ui';

interface HotelSelectionFilterFooterProps {
  isLoading: boolean;
  hotelsAmount: number;
}

const props = defineProps<HotelSelectionFilterFooterProps>();

interface HotelSelectionFilterFooterEmits {
  (eventName: 'resetFilters'): void;
  (eventName: 'confirmFilters'): void;
}

const emit = defineEmits<HotelSelectionFilterFooterEmits>();

const { t } = i18n.global;

const buttonState = computed<AppButtonState>(() =>
  props.isLoading ? 'loadingSpinner' : 'enabled'
);

const buttonText = computed<string>(() =>
  props.hotelsAmount === 0
    ? `${t('planner.no_result')}`
    : `${t('planner.show_x_results', [props.hotelsAmount])}`
);
</script>

<template>
  <div class="hotel-selection-filters-footer">
    <AppLinkButton
      class="reset-filters-button"
      :text="$t('planner.reset_hotel_filters')"
      size="m"
      @click="emit('resetFilters')"
    />
    <AppButton
      type="primary"
      :state="buttonState"
      size="medium"
      @click="emit('confirmFilters')"
    >
      {{ buttonText }}
    </AppButton>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-filters-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-16);
  .reset-filters-button {
    text-align: left;
  }
}
</style>
